import { PasswordState } from "../Types/PasswordTypes";

export const initialState: PasswordState = {
    minimunCharacters: { error: true, warningStyle: 'error' },
    capitalCharacter: { error: true, warningStyle: 'error' },
    numberCharacter: { error: true, warningStyle: 'error' },
    specialCharacter: { error: true, warningStyle: 'error' },
}